import { useEffect, useState } from "react";
import { db } from "./firebase.js";
import { collection, query, where, getDocs } from "firebase/firestore";

export default function Cohosts() {
  const [cohosts, setCohosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCohosts, setShowCohosts] = useState(false);
  const showVerifyBadge = false;

  useEffect(() => {
    const fetchCohosts = async () => {
      try {
        const q = query(collection(db, "users"), where("isCohost", "==", true));
        const snapshot = await getDocs(q);
        const results = snapshot.docs
          .map((doc) => doc.data())
          .filter((data) => !!data.turo_user_id); // ✅ Filter only those with turo_user_id
        setCohosts(results);
      } catch (err) {
        console.error("Failed to fetch cohosts:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCohosts();
  }, []);

  return (
    <div>
      <button
        onClick={() => setShowCohosts(!showCohosts)}
        className="relative text-blue-600 hover:underline"
      >
        Find Cohosts
      </button>

      {showCohosts && (
        <div className="absolute left-1/2 transform -translate-x-1/2 mt-4 w-[90vw] max-w-2xl bg-white shadow-lg border rounded p-6 z-50 text-left overflow-y-auto max-h-[80vh]">
          <button
            onClick={() => setShowCohosts(false)}
            className="absolute top-2 right-2 text-gray-500 hover:text-black text-lg"
          >
            ×
          </button>

          {loading ? (
            <p className="text-center text-gray-500">Loading cohosts...</p>
          ) : cohosts.length < 4 ? (
            <p className="text-center text-gray-500">Coming soon!</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {cohosts.map((cohost, index) => {
                const turoLink = `https://turo.com/us/en/drivers/${cohost.turo_user_id}`;

                return (
                  <div
                    key={index}
                    className="bg-white shadow-md rounded-lg p-4 border"
                  >
                    <h3 className="text-lg font-semibold mb-2">
                      Cohost Profile
                    </h3>

                    <a
                      href={turoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline break-all"
                    >
                      {turoLink}
                    </a>

                    <p className="text-sm mt-3 text-gray-800 whitespace-pre-wrap">
                      {cohost.cohost_description || "No description provided."}
                    </p>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
